export default __webpack_public_path__ + "static/media/lock-circle.2465d3e9.svg";